import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {RelayScriptRule} from '../classes/RelayScriptRule';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root'
})
export class RelayScriptRuleService {

  constructor(private httpClient: HttpClient) { }

  public getAll(): Observable<RelayScriptRule[]> {
    return this.httpClient.get<RelayScriptRule[]>(`${environment.backendApiUrl}/v1/relay-script-rules`, httpOptions);
  }

  public addOrEdit(relayScriptRule: RelayScriptRule): Observable<void> {
    console.log(relayScriptRule);
    return this.httpClient.put<void>(`${environment.backendApiUrl}/v1/relay-script-rules`, relayScriptRule, httpOptions);
  }

  public delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${environment.backendApiUrl}/v1/relay-script-rules/` + id, httpOptions);
  }

}
